import { useEffect } from "react";
import { Form, Typography, Image, Alert } from "antd";
import Logo from "../../assets/images/auth-logo.png";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/CustomButton/Button";
import CustomInput from "../../components/CustomInput/Input";
import { sendEmailOTP, clearAuthError } from "../../redux/slices/AuthSlice";
import { useDispatch, useSelector } from "react-redux";
import { emailRules } from "../../helpers/helpers";
import { BTN_TXT, DESC_TXT, GLOBAL_CONSTANTS } from "../../constants/constants";

const { Title, Text } = Typography;

const ForgotPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);

  useEffect(() => {
    return () => {
      dispatch(clearAuthError());
    };
  }, [dispatch]);

  const onFinish = async (values) => {
    const res = await dispatch(sendEmailOTP(values.email))

    if (res.payload.statusCode === 200) {
      const messageId = res.payload.response?.result?.message || res.payload.response;
      navigate('/otp', { state: { email: values.email, messageId } })
    }
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-logo-container">
        <Image preview={false} src={Logo} alt="Logo" />
      </div>
      <div className="forgot-password-card-container">
        <Title level={2}>{GLOBAL_CONSTANTS.FORGOT_PWD}</Title>
        <Text>
          {DESC_TXT.FORGOT_PWD_INFO_TEXT}
        </Text>
        <Form
          layout="vertical"
          className="forgot-form"
          onFinish={onFinish}
          initialValues={{ remember: true }}
        >
          <CustomInput
            label="Email"
            name="email"
            placeholder="Your Email"
            rules={emailRules("")}
          />

          {error && <Alert message={error} type="error" showIcon />}

          <Form.Item>
            <CustomButton
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              style={{ marginTop: 30 }}
            >
              {BTN_TXT.SEND_OTP}
            </CustomButton>
          </Form.Item>
          <Form.Item>
            <CustomButton
              type="text"
              block
              style={{ fontWeight: 600, padding: 0 }}
              onClick={() => navigate("/login")}
            >
              {BTN_TXT.BACK}
            </CustomButton>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default ForgotPassword;
